import React from 'react';
import { AiTextGenerationPresetOption, customPromptPresetOption } from '../../../../services/wws-api/wws-api.service';
import { ConfigurableFloatingMenu, FloatingMenuOption } from '../../../FloatingMenu/FloatingMenu';

const mapPresetToFloatingMenuOption = (preset: AiTextGenerationPresetOption): FloatingMenuOption => ({
  label: preset.label,
  value: preset.value,
  description: preset.description,
  testId: `ai-floating-menu-option-${preset.value}`,
});

interface AiFloatingMenuProps {
  presetOptions: AiTextGenerationPresetOption[];
  onOptionSelect: (optionValue: string) => void;
  isMenuOpen: boolean;
  menuDirection?: 'up' | 'down';
}

const AiFloatingMenu = ({ presetOptions, onOptionSelect, isMenuOpen, menuDirection = 'down' }: AiFloatingMenuProps) => {
  // Transform AI preset options to generic floating menu options
  const transformedOptions: FloatingMenuOption[] = presetOptions.map(option => mapPresetToFloatingMenuOption(option));

  // Add custom prompt option
  const customPromptOption: FloatingMenuOption = mapPresetToFloatingMenuOption(customPromptPresetOption);

  const allOptions = [...transformedOptions, customPromptOption];

  return (
    <ConfigurableFloatingMenu
      options={allOptions}
      onOptionSelect={onOptionSelect}
      isMenuOpen={isMenuOpen}
      menuDirection={menuDirection}
      testId="ai-floating-menu"
    />
  );
};

export default AiFloatingMenu;
